module.exports = __webpack_public_path__ + "b8901dc5e571944d850ef116ebd922f0.MP3";